import React from 'react';
import './index.less';
import classNames from 'classnames';
import { Checkbox } from 'antd';

export interface IABSCheckboxProps {
  style?: React.CSSProperties;
  className?: string;
  content: string | React.ReactNode;
  value: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (e: any) => void;
  removeMarginRight?: boolean;
}

class ABSCheckbox extends React.Component<IABSCheckboxProps> {
  render() {
    const { className, style, content, value, disabled, checked, onChange, removeMarginRight } = this.props;
    const classs = classNames(className, {'remove-margin-right': removeMarginRight });
    const rest = checked || checked === false ? { checked: checked } : null;
    return (
      <div className="abs-checkbox">
        <Checkbox style={style} 
          value={value} 
          disabled={disabled} 
          {...rest}
          onChange={onChange}
          className={classs}>
          <span className="abs-checkbox-text">{content}</span>
        </Checkbox>
      </div>
    );
  }
}

export default ABSCheckbox;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSCheckbox/index.tsx